import { Dispatch, SetStateAction } from "react";

import appBubble1 from "../../assets/images/shared/bubble.png";
import appBubble2 from "../../assets/images/shared/bubble2.png";
import bubbleImage from "../../assets/images/menu/disney/bubble-xl.webp";
import webBubble1 from "../../assets/images/menu/disneyWeb/bubble1.svg";
import webBubble2 from "../../assets/images/menu/disneyWeb/bubble2.png";
import webBubble3 from "../../assets/images/menu/disneyWeb/bubble3.svg";
import { MenuItemType } from "../../types";
import cn from "../../utils/cn";
import ClubAppMenuItem from "./ClubAppMenuItem";
import MenuItem from "./MenuItem";
import {
  menuItemStyles,
  menuLayout,
  slotCharacters,
  slotDelay,
} from "./constants";
import { tabletMaxWidth } from "../../constants/layout";

export default function DisneyMenuBubbles({
  setSelectedMenuItem,
  setShowDisneyMenu,
  isWeb,
  hasBedtime,
}: {
  setSelectedMenuItem: Dispatch<SetStateAction<MenuItemType>>;
  setShowDisneyMenu: Dispatch<SetStateAction<boolean | null>>;
  isWeb?: boolean;
  hasBedtime?: boolean;
}) {
  const itemProps = {
    setSelectedMenuItem,
    setShowDisneyMenu,
    isWeb,
  };
  const names = slotCharacters(Boolean(hasBedtime));
  const decorativeBubbles = isWeb
    ? { src1: webBubble1, src2: webBubble2, src3: webBubble3 }
    : { src1: appBubble1, src2: appBubble2, src3: appBubble1 };

  return (
    <div
      className={menuLayout.bubbleGroup}
      style={{ maxWidth: tabletMaxWidth }}
    >
      <div className={menuLayout.bubbleRow1}>
        <MenuItem name={names[0]} delay={slotDelay(0)} {...itemProps} />
        <MenuItem
          name={names[1]}
          className={menuLayout.bubble2}
          delay={slotDelay(1)}
          {...itemProps}
        />
      </div>

      <div className={menuLayout.bubbleRow2}>
        <MenuItem name={names[2]} delay={slotDelay(2)} {...itemProps} />
        <MenuItem
          name={names[3]}
          className={menuLayout.bubble4}
          delay={slotDelay(3)}
          {...itemProps}
        />
      </div>

      <div className={menuLayout.bubbleRow3}>
        <MenuItem name={names[4]} delay={slotDelay(4)} {...itemProps} />
        {isWeb ? (
          <ClubAppMenuItem
            className={menuLayout.bubble6}
            delay={slotDelay(5)}
          />
        ) : names[5] ? (
          <MenuItem
            name={names[5]}
            className={menuLayout.bubble6}
            delay={slotDelay(5)}
            {...itemProps}
          />
        ) : (
          <div
            className={cn(
              "disney-menu-slide-in shrink-0 bg-cover [--disney-menu-opacity:0.6]",
              menuItemStyles.emptyBubble,
              menuLayout.bubble6,
            )}
            style={{
              backgroundImage: `url(${bubbleImage})`,
              animationDelay: slotDelay(5),
            }}
          />
        )}
      </div>

      <img
        src={decorativeBubbles.src1}
        alt=""
        className={cn("floating", menuLayout.floatingBubble1)}
      />
      <img
        src={decorativeBubbles.src2}
        alt=""
        className={cn("floating", menuLayout.floatingBubble2)}
        style={{ animationDelay: "0.7s" }}
      />
      <img
        src={decorativeBubbles.src3}
        alt=""
        className={cn("floating", menuLayout.floatingBubble3)}
        style={{ animationDelay: "1.3s" }}
      />
    </div>
  );
}
